import React from 'react'
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next'
import { connect, useSelector } from 'react-redux'
import { Fade, Paper, Popper } from '@material-ui/core'
import Scrollbars from 'react-custom-scrollbars'
import { License } from '../../../../../components/Template/Premium'
import Header from '../../../../../components/Template/Premium/Header/Header'
import { getUserSettings } from '../../../../../reducers/userObject/selectors/settings'
import AndroidIcon from '../../../../../components/Template/Premium/Icons/AndroidIcon'
import { ILicense, LicenseType } from '../../../../../models/License'
import ICalendarIcon from '../../../../../components/Template/Premium/Icons/ICalendarIcon'
import BookingIcon from '../../../../../components/Template/Premium/Icons/BookingIcon'
import IosIcon from '../../../../../components/Template/Premium/Icons/IosIcon'
import PremiumIcon from '../../../../../components/Template/Premium/Icons/PremiumIcon'
import InvoiceIcon from '../../../../../components/Template/Premium/Icons/InvoiceIcon'
import getFinalValidLicenses from '../../../../../utils/License/getFinalValidLicenses'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import PremiumBasicIcon from '../../../../../components/Template/Premium/Icons/PremiumBasic'
import PremiumAssistentIcon from '../../../../../components/Template/Premium/Icons/PremiumAsisstent'
import PremiumProfessionalIcon from '../../../../../components/Template/Premium/Icons/PremiumProfessional'
import { theme } from '../../../../../theme'
import { isAllInOneLicenseValid, isNewPremiumLicenseValid } from '../../../../../reducers/userAccount/selectors/license'
import { isUserNewPackage, isUserNewPremium } from '../../../../../reducers/userAccount/selectors/userAccount'

function PremiumLicenses({
                           show,
                           anchor,
                           close,
                           validLicenses,
                           size = 1,
                           newPremium,
                           formatDate,
                           setCanClose,
                         }: IPremiumLicenses & IPremiumLicensesDispatch & WithTranslation & IWithSize) {
  const finalLicenses = getFinalValidLicenses(validLicenses)
  const isSub = finalLicenses.active?.some(license => license.sub != null)
  const isAllInOnePriceGroup = useSelector(isUserNewPremium)
  const isAllInOneSubUser = (useSelector(isAllInOneLicenseValid) || isAllInOnePriceGroup) && isSub
  const newPacakgePremium = useSelector(isNewPremiumLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isNewPremiumSubUser =
    newPacakgePremium && isNewPremiumPriceGroup && isSub
  const { t } = useTranslation()

  return (
    <Popper
      open={show}
      anchorEl={anchor.current}
      style={{
        // minWidth: '366px',
        marginTop: ((isSub && newPremium) || newPremium) ? 'unset' : `${-5 * size}px`,
        zIndex: ((isSub && newPremium) || newPremium) ? 1 : 50,
      }}
      onMouseLeave={close}
      transition={true}
      placement={isSub && newPremium ? 'bottom-start' : undefined}
      popperOptions={{
        positionFixed: !(isSub && newPremium),
      }}
      onMouseEnter={setCanClose}
      modifiers={{
        arrow: {
          enabled: true,
        },
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={150}>
          <div>
            <div>
              <div
                style={{
                  borderColor: 'transparent transparent white transparent',
                  borderStyle: 'solid',
                  borderWidth: `0 ${10 * size}px ${10 * size}px ${10 * size}px`,
                  height: '0',
                  marginBottom: '0px',
                  marginTop: `${-10 * size}px`,
                  pointerEvents: 'none',
                  position: 'relative',
                  width: '0',
                }}
                x-arrow=""
              />
              <div>
                <Paper style={isSub && newPremium ? { borderRadius: '0px' } : undefined}>
                  <Scrollbars
                    autoHeight={true}
                    autoHide={true}
                    hideTracksWhenNotNeeded={true}
                    autoHeightMin={'50px'}
                    autoHeightMax={'650px'}
                  >
                    <Header
                      active={true}
                      label={t('BBO_934_active_services')}
                      size={size}
                      style={{
                        width: 'unset',
                      }}
                      validLicenses={finalLicenses.active}
                    />
                    {finalLicenses.active.map(license => (
                      <License
                        size={size}
                        icon={mapLicenseToIcon(license, size)}
                        label={t(mapLicenseToName(license, t,isNewPremiumPriceGroup))}
                        endTime={license.license}
                        sub={license.sub}
                        startTime={license.startLicense}
                        roomLimit={license.roomLimit}
                        rawEnd={license.rawDate}
                        formatDate={formatDate}
                        more={isAllInOneSubUser || isNewPremiumSubUser ? undefined : license.sub}
                      />
                    ))}
                    {finalLicenses.awaits.length !== 0 && (
                      <>
                        <Header
                          style={{
                            borderTop: `1px solid ${theme.colors.palette.emerald}`,
                            width: 'unset',
                          }}
                          active={false}
                          label={t('BED_5438_pending_services')}
                          size={size}
                          validLicenses={finalLicenses.awaits}
                        />
                        {finalLicenses.awaits.map(license => (
                          <License
                            size={size}
                            awaits={true}
                            icon={mapLicenseToIcon(
                              license,
                              size,
                              theme.colors.palette.slateGrey,
                            )}
                            sub={license.sub}
                            label={t(mapLicenseToName(license, t,isNewPremiumPriceGroup))}
                            endTime={license.license}
                            startTime={license.startLicense}
                            roomLimit={license.roomLimit}
                            rawEnd={license.rawDate}
                            formatDate={formatDate}
                            more={isAllInOneSubUser || isNewPremiumSubUser ? undefined : license.sub}
                          />
                        ))}
                      </>
                    )}
                  </Scrollbars>
                </Paper>
              </div>
            </div>
          </div>
        </Fade>
      )}
    </Popper>
  )
}

export const mapLicenseToIcon = (item, size = 1, color = undefined) => {
  switch (item.licenseType) {
    case LicenseType.LICENSE_INVOICE:
      return <InvoiceIcon color={color} size={size} />
    case LicenseType.LICENSE_ICALENDAR:
      return <ICalendarIcon color={color} size={size} />
    case LicenseType.LICENSE_BOOKING_COM:
      return <BookingIcon color={color} size={size} />
    case LicenseType.LICENSE_WEB_IOS:
      return <IosIcon color={color} size={size} />
    case LicenseType.LICENSE_WEB_ANDROID:
      return <AndroidIcon color={color} size={size} />
    case LicenseType.LICENSE_WEB_ANDROID_IOS:
      return <PremiumIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_ROOMS:
      return <PremiumIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_BASIC:
      return <PremiumBasicIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_ASSISTENT:
      return <PremiumAssistentIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_PROFESSIONAL:
      return <PremiumProfessionalIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_LITE:
      return <PremiumIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_PLUS:
      return <PremiumIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_PRO:
      return <PremiumIcon color={color} size={size} />
    case LicenseType.LICENSE_PREMIUM_MAX:
      return <PremiumIcon color={color} size={size} />
  }
}

export const mapLicenseToName = (item, t, isNewPremiumPriceGroup?) => {
  switch (item.licenseType) {
    case LicenseType.LICENSE_INVOICE:
      return 'z5020_main_menu_invoice'
    case LicenseType.LICENSE_ICALENDAR:
      return 'iCalendar'
    case LicenseType.LICENSE_BOOKING_COM:
      return 'Booking.com'
    case LicenseType.LICENSE_WEB_IOS:
      return 'Web App + iOS'
    case LicenseType.LICENSE_WEB_ANDROID:
      return 'Web App + Android'
    case LicenseType.LICENSE_WEB_ANDROID_IOS:
      return 'Web App + Android + iOS'
    case LicenseType.LICENSE_PREMIUM_ROOMS:
      return 'BedBooking Premium'
    case LicenseType.LICENSE_PREMIUM_BASIC:
      return 'Bedbooking Basic'
    case LicenseType.LICENSE_PREMIUM_ASSISTENT:
      return 'BedBooking Assistant'
    case LicenseType.LICENSE_PREMIUM_PROFESSIONAL:
      return 'Bedbooking Professional'
    case LicenseType.LICENSE_PREMIUM_LITE:
      if (isNewPremiumPriceGroup) {
        return t('BED_28884_plan') + ' ' + t('new_premium_plan_lite')
      } else {
        return 'BedBooking Premium'
      }

    case LicenseType.LICENSE_PREMIUM_PLUS:
      if (isNewPremiumPriceGroup) {
        return t('BED_28884_plan') + ' ' + t('new_premium_plan_plus')
      } else {
        return 'BedBooking Premium'
      }
    case LicenseType.LICENSE_PREMIUM_PRO:
      if (isNewPremiumPriceGroup) {
        return t('BED_28884_plan') + ' ' + t('new_premium_plan_pro')
      } else {
        return 'BedBooking Premium'
      }
    case LicenseType.LICENSE_PREMIUM_MAX:
      if (isNewPremiumPriceGroup) {
        return t('BED_28884_plan') + ' ' + t('new_premium_plan_max')
      } else {
        return 'BedBooking Premium'
      }
  }
}

const mapStateToProps = (state): IPremiumLicenses => {
  const format = getUserSettings(state).dateFormat

  return {
    formatDate: format ? format.date : null,
  }
}

export default withTranslation()(
  connect<IPremiumLicenses,
    IPremiumLicensesDispatch,
    IPremiumLicenses & IWithSize>(mapStateToProps)(PremiumLicenses) as any,
) as any

export interface IPremiumLicenses {
  show?: boolean
  newPremium?: boolean
  anchor?: React.MutableRefObject<HTMLDivElement>
  validLicenses?: ILicense[]
  licenses?: ILicense[]
  formatDate?: string
  token?: string
}

export interface IPremiumLicensesDispatch {
  close?: () => void
  setCanClose?: () => void
}
